export const colors = [
    "black",
    "green",
    "red",
    "blue",
    "purple",
    "pink",
    "yellow",
    "orange",
    "brown",
    "grey", 
];
export const hexes = {
    green: "#388e3c",
    red: "#d32f2f",
    blue: "#1976d2",
    purple: "#7b1fa2",
    pink: "#c2185b",
    yellow: "#fbc02d",
    orange: "#f57c00",
    brown: "#5d4037",
    grey: "#455a64",
    black: "#212121"
};
